export const SPECIALIST_PHOTOS = [
  '/img/concierge/specialist-1.jpg',
  '/img/concierge/specialist-2.jpg',
  '/img/concierge/specialist-3.jpg',
];

export const CALLUM_PHOTO = '/img/concierge/callum.jpg';

export const PARTY_PHOTO = '/img/concierge/party.jpg';

export const CONFERENCE_PHOTO = '/img/concierge/conference.jpg';

// The navbar ships in the common bundle while the search page and Location Pages have their
// own, so the area they show is handed over on window rather than through a shared module.
const AREA_PREFILL_KEY = '__TGV_CONCIERGE_AREA_PREFILL';

export function setAreaPrefill(prefill) {
  window[AREA_PREFILL_KEY] = prefill;
}

export function getAreaPrefill() {
  return window[AREA_PREFILL_KEY] ?? {};
}

export function withPrefill(url, prefill = {}) {
  const urlWithPrefill = new URL(url);

  Object.entries(prefill).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      urlWithPrefill.searchParams.set(key, value);
    }
  });

  return urlWithPrefill.toString();
}

export function getBoundariesCenter(boundaries = {}) {
  const latitudes = [boundaries.latitude_from, boundaries.latitude_to];
  const longitudes = [boundaries.longitude_from, boundaries.longitude_to];

  if ([...latitudes, ...longitudes].some(value => !value && value !== 0)) {
    return {};
  }

  const middle = ([from, to]) => ((Number(from) + Number(to)) / 2).toFixed(4);

  return {
    lat: middle(latitudes),
    lng: middle(longitudes),
  };
}

export function onceVisible(element, callback) {
  if (!('IntersectionObserver' in window)) {
    callback();
    return () => {};
  }

  const observer = new IntersectionObserver((entries) => {
    if (entries.some(entry => entry.isIntersecting)) {
      observer.disconnect();
      callback();
    }
  }, { threshold: 0.5 });
  observer.observe(element);

  return () => observer.disconnect();
}

const CALENDLY_SCRIPT_URL = 'https://assets.calendly.com/assets/external/widget.js';
const CALENDLY_STYLES_URL = 'https://assets.calendly.com/assets/external/widget.css';

// Loads Calendly's pop-up widget ahead of the click, so the click can open it straight away.
export function preloadCalendly() {
  if (document.querySelector(`script[src="${CALENDLY_SCRIPT_URL}"]`)) {
    return;
  }

  const styles = document.createElement('link');
  styles.rel = 'stylesheet';
  styles.href = CALENDLY_STYLES_URL;
  document.head.appendChild(styles);

  const script = document.createElement('script');
  script.src = CALENDLY_SCRIPT_URL;
  script.async = true;
  document.head.appendChild(script);
}

// Until the widget has loaded, the click is left to the link, which opens the booking page in a new tab.
export function openCalendlyPopup(event, url) {
  if (!window.Calendly) {
    return;
  }

  event.preventDefault();
  window.Calendly.initPopupWidget({ url });
}
